const BASE_URL = 'https://api.themoviedb.org/3/';

const API_KEY = '27479e60681c50d3081750a08a447d06';

export { BASE_URL, API_KEY };